module.exports = __webpack_public_path__ + "static/img/service2.882829f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service2.jpg
// module id = A5I7
// module chunks = 0